import React from 'react';
import AuthWrapper from '../components/molecules/AuthWrapper';
import HomeTemplate from '../components/templates/Home';

const Home = () => {
  return <AuthWrapper renderProps={HomeTemplate} />;
};

export default Home;
